import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import type { DynamicDialogOptions } from "primevue/dynamicdialogoptions";

type GlobalDialog = {
  open: (content: any, options?: DynamicDialogOptions) => DynamicDialogInstance;
};

let dialog: GlobalDialog;

// Returns the global dialog instance.
// Only the GlobalDialogService component should provide the dialog instance.
// This is a way to work around the limitation that the useDialog hook of PrimeVue must be called in script setup.
// Using this composable, the dialog can be referenced outside Vue components.
export function useGlobalDialog(d?: GlobalDialog) {
  if (d) {
    dialog = d;
  }

  return {
    dialog,
  };
}
